{
  "REPORT": {
    "HEADER": "Conversații",
    "LOADING_CHART": "Încărcare date grafic...",
    "NO_ENOUGH_DATA": "Nu am primit suficiente date pentru a genera raportul. Vă rugăm să încercați din nou mai târziu.",
    "DOWNLOAD_AGENT_REPORTS": "Descărcați rapoartele agenților",
    "DATA_FETCHING_FAILED": "Preluarea datelor a eșuat, te rugăm să încerci din nou mai târziu.",
    "SUMMARY_FETCHING_FAILED": "Preluarea rezumatului a eșuat, te rugăm să încerci mai târziu.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversații",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mesaje primite",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mesaje trimise",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primul timp de răspuns",
        "DESC": "(Medie)",
        "INFO_TEXT": "Numărul total de conversații utilizate pentru calcul:",
        "TOOLTIP_TEXT": "Primul timp de răspuns este {metricValue} (pe baza conversațiilor {conversationCount})"
      },
      "RESOLUTION_TIME": {
        "NAME": "Timp Rezolutie",
        "DESC": "(Medie)",
        "INFO_TEXT": "Numărul total de conversații utilizate pentru calcul:",
        "TOOLTIP_TEXT": "Timpul de rezolvare este {metricValue} (pe baza conversațiilor {conversationCount})"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Număr de rezoluții",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Număr de rezoluții",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Astăzi",
      "YESTERDAY": "Ieri",
      "LAST_7_DAYS": "Ultimele 7 zile",
      "LAST_30_DAYS": "Ultimele 30 zile",
      "THIS_MONTH": "Luna aceasta",
      "LAST_MONTH": "Luna trecută",
      "LAST_3_MONTHS": "Ultimele 3 luni",
      "LAST_6_MONTHS": "Ultimele 6 luni",
      "LAST_YEAR": "Anul trecut",
      "CUSTOM_DATE_RANGE": "Interval de date particularizat"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplică",
      "PLACEHOLDER": "Selectarea intervalului de date"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Grupează după",
    "DURATION_FILTER_LABEL": "Durata",
    "GROUPING_OPTIONS": {
      "DAY": "Zi",
      "WEEK": "Săptămână",
      "MONTH": "Luna",
      "YEAR": "Anul"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Zi"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Zi"
      },
      {
        "id": 2,
        "groupBy": "Săptămână"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Zi"
      },
      {
        "id": 2,
        "groupBy": "Săptămână"
      },
      {
        "id": 3,
        "groupBy": "Luna"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Zi"
      },
      {
        "id": 2,
        "groupBy": "Săptămână"
      },
      {
        "id": 3,
        "groupBy": "Luna"
      }
    ],
    "BUSINESS_HOURS": "Program de lucru",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Niciun rezultat găsit"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Conversații: {count}",
      "RESULT_COUNT_MESSAGE": "Mesaje: {count}",
      "EMPTY": "Nu s-au găsit înregistrări pentru această bară.",
      "ERROR": "Înregistrările nu au putut fi încărcate. Încercați din nou.",
      "LOAD_MORE": "Încarcă mai multe",
      "PREVIOUS_BUCKET": "Bara anterioară",
      "NEXT_BUCKET": "Bara următoare",
      "UNKNOWN_CONTACT": "Contact necunoscut",
      "UNKNOWN_INBOX": "Inbox necunoscut",
      "UNASSIGNED_AGENT": "Neatribuită",
      "NO_MESSAGE_CONTENT": "Mesaj fără conținut",
      "MESSAGE_CREATED_AT": "Mesaj creat la {time}",
      "EVENT_OCCURRED_AT": "Eveniment produs la {time}",
      "INCOMING_MESSAGE": "Mesaj primit",
      "OUTGOING_MESSAGE": "Mesaj trimis",
      "VIEW_ALL": "Vezi în conversații",
      "VIEW_ALL_LIMIT": "Doar barele cu cel mult {limit} conversații se deschid în lista de conversații.",
      "HIDDEN_COUNT": "Nu sunt afișate deoarece nu sunteți membru al inboxului lor: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Prezentare generală a agenților",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Încărcare date grafic...",
    "NO_ENOUGH_DATA": "Nu am primit suficiente date pentru a genera raportul. Vă rugăm să încercați din nou mai târziu.",
    "DOWNLOAD_AGENT_REPORTS": "Descărcați rapoartele agenților",
    "FILTER_DROPDOWN_LABEL": "Selectează agent",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversații",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mesaje primite",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mesaje trimise",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primul timp de răspuns",
        "DESC": "(Medie)",
        "INFO_TEXT": "Numărul total de conversații utilizate pentru calcul:",
        "TOOLTIP_TEXT": "Primul timp de răspuns este {metricValue} (pe baza conversațiilor {conversationCount})"
      },
      "RESOLUTION_TIME": {
        "NAME": "Timp Rezolutie",
        "DESC": "(Medie)",
        "INFO_TEXT": "Numărul total de conversații utilizate pentru calcul:",
        "TOOLTIP_TEXT": "Timpul de rezolvare este {metricValue} (pe baza conversațiilor {conversationCount})"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Număr de rezoluții",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Ultimele 7 zile"
      },
      {
        "id": 1,
        "name": "Ultimele 30 zile"
      },
      {
        "id": 2,
        "name": "Ultimele 3 luni"
      },
      {
        "id": 3,
        "name": "Ultimele 6 luni"
      },
      {
        "id": 4,
        "name": "Anul trecut"
      },
      {
        "id": 5,
        "name": "Interval de date particularizat"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplică",
      "PLACEHOLDER": "Selectarea intervalului de date"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Prezentare generală a etichetelor",
    "DESCRIPTION": "Urmăriți performanța etichetelor cu indicatori cheie, inclusiv conversații, timpi de răspuns, timpi de rezolvare și cazuri rezolvate.",
    "LOADING_CHART": "Încărcare date grafic...",
    "NO_ENOUGH_DATA": "Nu am primit suficiente date pentru a genera raportul. Vă rugăm să încercați din nou mai târziu.",
    "DOWNLOAD_LABEL_REPORTS": "Descărcarea rapoartelor de etichete",
    "FILTER_DROPDOWN_LABEL": "Selectați etichetă",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversații",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mesaje primite",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mesaje trimise",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primul timp de răspuns",
        "DESC": "(Medie)",
        "INFO_TEXT": "Numărul total de conversații utilizate pentru calcul:",
        "TOOLTIP_TEXT": "Primul timp de răspuns este {metricValue} (pe baza conversațiilor {conversationCount})"
      },
      "RESOLUTION_TIME": {
        "NAME": "Timp Rezolutie",
        "DESC": "(Medie)",
        "INFO_TEXT": "Numărul total de conversații utilizate pentru calcul:",
        "TOOLTIP_TEXT": "Timpul de rezolvare este {metricValue} (pe baza conversațiilor {conversationCount})"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Număr de rezoluții",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Ultimele 7 zile"
      },
      {
        "id": 1,
        "name": "Ultimele 30 zile"
      },
      {
        "id": 2,
        "name": "Ultimele 3 luni"
      },
      {
        "id": 3,
        "name": "Ultimele 6 luni"
      },
      {
        "id": 4,
        "name": "Anul trecut"
      },
      {
        "id": 5,
        "name": "Interval de date particularizat"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplică",
      "PLACEHOLDER": "Selectarea intervalului de date"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Prezentare generală a inboxului",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Încărcare date grafic...",
    "NO_ENOUGH_DATA": "Nu am primit suficiente date pentru a genera raportul. Vă rugăm să încercați din nou mai târziu.",
    "DOWNLOAD_INBOX_REPORTS": "Descărcarea rapoartelor inbox",
    "FILTER_DROPDOWN_LABEL": "Selectați Inbox",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversații",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mesaje primite",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mesaje trimise",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primul timp de răspuns",
        "DESC": "(Medie)",
        "INFO_TEXT": "Numărul total de conversații utilizate pentru calcul:",
        "TOOLTIP_TEXT": "Primul timp de răspuns este {metricValue} (pe baza conversațiilor {conversationCount})"
      },
      "RESOLUTION_TIME": {
        "NAME": "Timp Rezolutie",
        "DESC": "(Medie)",
        "INFO_TEXT": "Numărul total de conversații utilizate pentru calcul:",
        "TOOLTIP_TEXT": "Timpul de rezolvare este {metricValue} (pe baza conversațiilor {conversationCount})"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Număr de rezoluții",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Ultimele 7 zile"
      },
      {
        "id": 1,
        "name": "Ultimele 30 zile"
      },
      {
        "id": 2,
        "name": "Ultimele 3 luni"
      },
      {
        "id": 3,
        "name": "Ultimele 6 luni"
      },
      {
        "id": 4,
        "name": "Anul trecut"
      },
      {
        "id": 5,
        "name": "Interval de date particularizat"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplică",
      "PLACEHOLDER": "Selectarea intervalului de date"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Prezentare generală a echipei",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Încărcare date grafic...",
    "NO_ENOUGH_DATA": "Nu am primit suficiente date pentru a genera raportul. Vă rugăm să încercați din nou mai târziu.",
    "DOWNLOAD_TEAM_REPORTS": "Descărcați rapoartele echipei",
    "FILTER_DROPDOWN_LABEL": "Selectați echipa",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversații",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mesaje primite",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mesaje trimise",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Primul timp de răspuns",
        "DESC": "(Medie)",
        "INFO_TEXT": "Numărul total de conversații utilizate pentru calcul:",
        "TOOLTIP_TEXT": "Primul timp de răspuns este {metricValue} (pe baza conversațiilor {conversationCount})"
      },
      "RESOLUTION_TIME": {
        "NAME": "Timp Rezolutie",
        "DESC": "(Medie)",
        "INFO_TEXT": "Numărul total de conversații utilizate pentru calcul:",
        "TOOLTIP_TEXT": "Timpul de rezolvare este {metricValue} (pe baza conversațiilor {conversationCount})"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Număr de rezoluții",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Ultimele 7 zile"
      },
      {
        "id": 1,
        "name": "Ultimele 30 zile"
      },
      {
        "id": 2,
        "name": "Ultimele 3 luni"
      },
      {
        "id": 3,
        "name": "Ultimele 6 luni"
      },
      {
        "id": 4,
        "name": "Anul trecut"
      },
      {
        "id": 5,
        "name": "Interval de date particularizat"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplică",
      "PLACEHOLDER": "Selectarea intervalului de date"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Rapoarte CSAT",
    "NO_RECORDS": "Nu există răspunsuri predefinite disponibile în acest cont.",
    "DOWNLOAD": "Descărcați rapoartele CSAT",
    "DOWNLOAD_FAILED": "Descărcarea rapoartelor CSAT a eșuat",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Alege agenți"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contact",
        "AGENT_NAME": "Agent atribuit",
        "RATING": "Evaluare",
        "FEEDBACK_TEXT": "Comentariu feedback"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Răspunsuri totale",
        "TOOLTIP": "Numărul total de răspunsuri colectate"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Scorul de satisfacție",
        "TOOLTIP": "Numărul total de răspunsuri pozitive / Numărul total de răspunsuri * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Rata de răspuns",
        "TOOLTIP": "Numărul total de răspunsuri / Numărul total de mesaje de sondaj CSAT trimise * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Număr de conversații",
        "TOOLTIP": "Numărul total de conversații cu mesaje de la bot"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Număr de răspunsuri",
        "TOOLTIP": "Numărul total de mesaje trimise"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Număr de răspunsuri AI",
        "TOOLTIP": "Numărul total de mesaje de răspuns trimise de bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Număr de răspunsuri pregătite",
        "TOOLTIP": "Numărul total de sugestii copilot pregătite de bot pentru agenți"
      },
      "SUCCESS_RATE": {
        "LABEL": "Rezolvate de AI",
        "TOOLTIP": "Procentul de conversații rezolvate de AI fără predare către agent"
      },
      "RESOLVE_TIME": {
        "LABEL": "Timp de rezolvare",
        "TOOLTIP": "Timpul median de la primul mesaj al clientului până la ultimul mesaj al bot-ului/agentului"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "LABEL": "Grupează după",
      "NONE": "Nu grupa",
      "INBOXES": "Inbox-uri",
      "LABELS": "Etichete"
    },
    "GROUPED": {
      "CHART_TITLE": "Distribuție pe grupuri",
      "BACK_TO_ALL": "Afișează tot",
      "TABLE": {
        "INBOX": "Inbox",
        "LABEL": "Etichetă",
        "CONVERSATIONS": "Conversații",
        "MESSAGES": "Mesaje",
        "MESSAGES_TOOLTIP": "Numărul total de mesaje trimise",
        "AI_MESSAGES": "Răspunsuri AI",
        "AI_MESSAGES_TOOLTIP": "Numărul total de răspunsuri AI, urmat de numărul de evaluări pozitive și negative ale utilizatorilor finali",
        "THUMBS_UP_TOOLTIP": "Numărul de răspunsuri AI evaluate pozitiv (degetul mare în sus) de utilizatorii finali",
        "THUMBS_DOWN_TOOLTIP": "Numărul de răspunsuri AI evaluate negativ (degetul mare în jos) de utilizatorii finali",
        "AI_PERCENTAGE": "AI %",
        "AI_PERCENTAGE_TOOLTIP": "Procentul de răspunsuri AI din toate mesajele din acest grup",
        "PREPARED": "Răspunsuri pregătite",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Procentul de mesaje din toate mesajele care aparțin acestui grup",
        "BOT_RESPONSES": "% răspunsuri AI",
        "SUGGESTION_USED": "Răspunsuri utilizate",
        "SUGGESTION_USED_TOOLTIP": "Procentul de răspunsuri pregătite din acest grup care au fost utilizate de agenți",
        "SUGGESTION_NOT_USED": "Răspunsuri neutilizate",
        "SUGGESTION_NOT_USED_TOOLTIP": "Procentul de mesaje din acest grup care aveau un răspuns pregătit dar nu a fost utilizat"
      },
      "NOTES": {
        "TITLE": "Cum sunt calculate metricile",
        "CONVERSATIONS": "Numărul de conversații care au cel puțin un mesaj trimis în perioada selectată.",
        "MESSAGES": "Numărul total de mesaje trimise (non-private) în perioada selectată. Aceasta include atât mesajele generate de AI, cât și cele scrise de om.",
        "PERCENTAGE": "Ponderea mesajelor acestui grup din toate mesajele trimise în toate grupurile.",
        "AI_MESSAGES": "Numărul de mesaje trimise automat de botul AI (fără a include răspunsurile pregătite pentru agenți). Numerele dintre paranteze arată câte dintre aceste răspunsuri au fost evaluate pozitiv (degetul mare în sus) și negativ (degetul mare în jos) de utilizatorii finali.",
        "BOT_RESPONSES_PCT": "Ponderea răspunsurilor AI ale acestui grup din toate mesajele trimise în acest grup.",
        "PREPARED": "Numărul de sugestii copilot (răspunsuri pregătite) generate de botul AI pentru agenți în perioada selectată. Acestea sunt mesaje private vizibile doar pentru agenți și nu sunt numărate ca mesaje trimise, deci acest număr poate să nu coreleze cu coloana Mesaje.",
        "SUGGESTION_USED": "Procentul de răspunsuri pregătite din acest grup care au fost utilizate de agenți. Acesta poate să nu coreleze cu numărul de răspunsuri pregătite, deoarece poate include și sugestii generate în perioadele anterioare.",
        "SUGGESTION_NOT_USED": "Procentul de mesaje trimise din acest grup în care era disponibilă o sugestie copilot, dar agentul a răspuns fără a o folosi. Numărat doar când agentul a trimis efectiv un răspuns. Acesta poate să nu coreleze cu numărul de răspunsuri pregătite, deoarece poate include și sugestii generate în perioadele anterioare."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Prezentare generală",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Deschiderea conversațiilor",
      "LOADING_MESSAGE": "Încărcarea valorilor conversației...",
      "OPEN": "Deschide",
      "UNATTENDED": "Neasistat",
      "UNASSIGNED": "Neatribuit",
      "PENDING": "În aşteptare"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Trafic de conversație",
      "NO_CONVERSATIONS": "Fără conversații",
      "CONVERSATION": "{count} conversație",
      "CONVERSATIONS": "conversații {count}",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversațiile agenților",
      "LOADING_MESSAGE": "Măsurătorile agentului de încărcare...",
      "NO_AGENTS": "Nu există conversații ale agenților",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Deschide",
        "UNATTENDED": "Neasistat",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Echipa",
        "OPEN": "Deschide",
        "UNATTENDED": "Neasistat",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Starea agentului",
      "ONLINE": "Online",
      "BUSY": "Ocupat",
      "OFFLINE": "Deconectat"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Duminică",
    "MONDAY": "Luni",
    "TUESDAY": "Marți",
    "WEDNESDAY": "Miercuri",
    "THURSDAY": "Joi",
    "FRIDAY": "Vineri",
    "SATURDAY": "Sâmbătă"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Niciun rezultat găsit",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Nume agent",
        "INBOXES": "Nume Inbox",
        "LABELS": "Nume etichetă",
        "TEAMS": "Numele echipei"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Inbox",
      "AGENTS": "Agent",
      "LABELS": "Etichetă",
      "TEAMS": "Echipa"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Conversație",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Subtotal",
    "NO_TEAM": "Fără echipă",
    "GROUP_BY_TEAMS": "Grupează după echipe",
    "INBOX": "Inbox",
    "AGENT": "Agent",
    "TEAM": "Echipa",
    "LABEL": "Etichetă",
    "TOTAL": "Total",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Număr de rezoluții",
    "CONVERSATIONS": "Conversații",
    "OUTGOING_CHATS": "Chaturi trimise",
    "OUTGOING_EMAILS": "Emailuri trimise",
    "PHONE_CALLS": "Apeluri telefonice",
    "INBOUND_CALLS": "Apeluri primite",
    "OUTBOUND_CALLS": "Apeluri efectuate",
    "TOTAL_ACTIVITIES": "Total activități",
    "ONLINE_TIME": "Timp online",
    "QUEUE_AVAILABLE_TIME": "Timp disponibil în coadă",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Numărul de mesaje trimise de acest agent",
      "OUTGOING_EMAILS": "Numărul de emailuri trimise de acest agent",
      "PHONE_CALLS": "Numărul total de apeluri telefonice atribuite acestui agent (suma apelurilor primite și efectuate)",
      "TOTAL_ACTIVITIES": "Numărul total de activități: apeluri primite + apeluri efectuate + chaturi trimise + emailuri trimise",
      "INBOUND_CALLS": "Numărul de apeluri telefonice primite atribuite acestui agent",
      "OUTBOUND_CALLS": "Numărul de apeluri telefonice efectuate atribuite acestui agent",
      "AVG_FIRST_RESPONSE_TIME": "Timpul mediu de la crearea conversației până la primul răspuns al agentului în conversațiile atribuite acestui agent",
      "AVG_RESOLUTION_TIME": "Timpul mediu de la crearea conversației până la rezolvare în conversațiile atribuite acestui agent",
      "AVG_REPLY_TIME": "Timpul mediu pe care clienții îl așteaptă între mesajul lor și răspunsul agentului în conversațiile atribuite acestui agent",
      "ONLINE_TIME": "Timpul total în care agentul a fost online sau ocupat în perioada selectată",
      "QUEUE_AVAILABLE_TIME": "Timpul total în care agentul a fost disponibil în cozile de telefon în perioada selectată"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Rapoarte telefon",
    "DESCRIPTION": "Urmăriți metricile apelurilor telefonice cu informații detaliate despre apelurile primite și efectuate, grupate după agent sau inbox pentru o analiză cuprinzătoare.",
    "AGENT_HEADER": "Rapoarte telefon - După agent",
    "INBOX_HEADER": "Rapoarte telefon - După inbox",
    "DOWNLOAD_BUTTON": "Descarcă rapoartele telefon",
    "DOWNLOAD_PHONE_REPORTS": "Descarcă rapoartele telefon",
    "GROUP_BY": {
      "LABEL": "Grupează după",
      "AGENT": "Agent",
      "INBOX": "Inbox"
    },
    "TABLE": {
      "AGENT_NAME": "Nume agent",
      "INBOX_NAME": "Nume inbox",
      "TOTAL_CALLS": "Total",
      "INBOUND_CALLS": "Primite",
      "OUTBOUND_CALLS": "Efectuate",
      "FAILED_OUTBOUND_CALLS": "Efectuate eșuate",
      "AVG_AGENT_HANDLED_DURATION": "Durată medie",
      "TOTAL_AGENT_HANDLED_DURATION": "Durată totală",
      "AVG_RINGING_TIME": "Timp mediu de sonerie",
      "CONNECTED_OUTBOUND_PERCENTAGE": "% reușite",
      "UNIQUE_CALLERS": "Apelanți unici",
      "UNIQUE_CALLED_CONTACTS": "Apelați unici",
      "UNANSWERED_MISSED_CALLS": "Ratate fără urmărire",
      "UNANSWERED_MISSED_PERCENTAGE": "% ratate fără răspuns",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Ratate fără urmărire, insuficient apelate înapoi",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "% ratate fără urmărire, insuficient apelate înapoi"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Numărul total al tuturor apelurilor (inclusiv neconectate)",
      "INBOUND_CALLS": "Numărul de apeluri conectate",
      "OUTBOUND_CALLS": "Numărul tuturor apelurilor efectuate (inclusiv neconectate)",
      "FAILED_OUTBOUND_CALLS": "Numărul de apeluri efectuate care nu au reușit să se conecteze",
      "AVG_AGENT_HANDLED_DURATION": "Durata medie a apelurilor gestionate de agenți",
      "TOTAL_AGENT_HANDLED_DURATION": "Durata totală a tuturor apelurilor gestionate de agenți",
      "AVG_RINGING_TIME": "Timpul mediu pe care apelurile l-au petrecut sunând înainte de a fi preluate",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Procentul de apeluri efectuate care au fost conectate cu succes",
      "UNIQUE_CALLERS": "Numărul de contacte unice care au efectuat apeluri primite",
      "UNIQUE_CALLED_CONTACTS": "Numărul de contacte unice care au fost apelate prin apeluri efectuate",
      "UNANSWERED_MISSED_CALLS": "Numărul de apeluri ratate pentru care nu s-a făcut niciun apel de retur reușit (apel conectat). Poate include apeluri care mai pot fi gestionate în cursul zilei lucrătoare",
      "UNANSWERED_MISSED_PERCENTAGE": "Procentul de apelanți unici ale căror apeluri au fost ratate fără urmărire (apeluri ratate fără răspuns / apelanți unici)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Numărul de apeluri ratate cu mai puțin de 2 încercări de apel de retur. Poate include apeluri care mai pot fi gestionate în cursul zilei lucrătoare",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Procentul de apelanți unici cu mai puțin de 2 încercări de apel de retur ((ratate fără urmărire - gestionate suficient) / apelanți unici)"
    },
    "EMPTY_STATE": {
      "TITLE": "Niciun date despre apeluri disponibile",
      "MESSAGE": "Nu există apeluri telefonice în intervalul de date selectat. Încercați să ajustați filtrele sau intervalul de date."
    }
  }
}
